<template>
  <div class="content-area">
    <hero-bar>
      {{ title }}
      <b-button
        slot="right"
        icon-left="content-save-off"
        type="is-warning"
        class="mr-3"
        tag="router-link"
        :to="{ name: 'users.index' }"
      >
        {{ $t('cancel') }}
      </b-button>
      <b-button
        slot="right"
        icon-left="content-save"
        type="is-link"
        :class="{ 'is-loading': isLoading }"
        @click="btnSubmit"
      >
        {{ $t('save') }}
      </b-button>
    </hero-bar>
    <section class="section is-main-section">
      <card-component
        :title="$t('userForm')"
        icon="ballot"
      >
        <form ref="form" @submit.prevent="submit">
          <b-field horizontal>
            <b-field>
              <b-input
                v-model="form.name"
                icon="account"
                :placeholder="$t('fullName')"
                name="name"
              />
            </b-field>

            <b-field>
              <b-input
                v-model="form.username"
                icon="account"
                type="text"
                :placeholder="$t('username')"
                name="username"
                validation-message="Kullanıcı adı zorunlu."
                required
              />
            </b-field>
          </b-field>

          <b-field horizontal>
            <b-field>
              <b-input
                v-model="form.email"
                icon="email"
                type="email"
                :placeholder="$t('email')"
                name="email"
              />
            </b-field>
          </b-field>

          <b-field horizontal>
            <b-field>
              <VuePhoneNumberInput
                ref="phonenumber"
                v-model="form.phonenumber"
                :default-country-code="phoneCountryCode"
                @update="phoneNumberUpdate"
              />
            </b-field>
          </b-field>

          <b-field horizontal>
            <b-field>
              <b-input
                v-model="form.password"
                icon="lock-question"
                type="password"
                :placeholder="$t('password')"
                name="password"
                :required="password_required"
              />
            </b-field>

            <b-field>
              <b-input
                id="confirm_password"
                ref="passwordconfirmation"
                v-model="form.password_confirmation"
                icon="lock-question"
                type="password"
                :placeholder="$t('passwordConfirmation')"
                name="password_confirmation"
                :required="password_required"
                @blur="checkPasswordMatch"
              />
            </b-field>
          </b-field>

          <hr>

          <b-field :label="$t('role')" horizontal class="mb-4">
            <b-select v-model="form.role_id" :placeholder="$t('selectRole')" required @input="form.departments = []; form.vehicle_types = []; form.areas = []">
              <option
                v-for="(role, index) in roles"
                :key="index"
                :value="role.id"
              >
                {{ $t('roles.' + role.id) }}
              </option>
            </b-select>
          </b-field>

          <b-field v-if="form.role_id != 5" :label="form.role_id == 3 ? [$t('department'), $t('vehicleType')].join(' & ') : $t('department')" horizontal class="mb-4 deparments-field">
            <b-dropdown
              v-model="form.departments"
              multiple
              scrollable
              max-height="200"
              aria-role="list"
              @input="checkIfEligibleToSelect('departments')"
            >
              <template #trigger>
                <!--<b-button icon-right="menu-down">
                  {{ form.departments.length ? $t('selected') + ': ' + form.departments.length : $t('selectDepartment') }}
                </b-button>-->
                <b-select :placeholder="form.departments.length ? $t('selected') + ': ' + form.departments.length : $t('selectDepartment')" />
              </template>
              <b-dropdown-item
                v-for="department in departments"
                :key="'department'+department.id"
                :value="department.id"
                aria-role="listitem"
              >
                <span>{{ department.name }}</span>
              </b-dropdown-item>
            </b-dropdown>

            <div v-if="form.role_id == 3" class="is-flex is-align-items-center">
              <span class="pr-3">veya</span>
              <b-dropdown
                v-model="form.vehicle_types"
                multiple
                scrollable
                max-height="200"
                aria-role="list"
                @input="checkIfEligibleToSelect('vehicle_types')"
              >
                <template #trigger>
                  <!--<b-button icon-right="menu-down">
                    {{ form.vehicle_types.length ? $t('selected') + ': ' + form.vehicle_types.length : $t('selectVehicleType') }}
                  </b-button>-->
                  <b-select :placeholder="form.vehicle_types.length ? $t('selected') + ': ' + form.vehicle_types.length : $t('selectVehicleType')" />
                </template>
                <b-dropdown-item
                  v-for="vehicleType in vehicleTypes"
                  :key="'vehicle_type'+vehicleType.id"
                  :value="vehicleType.id"
                  aria-role="listitem"
                >
                  <span>{{ vehicleType.name }}</span>
                </b-dropdown-item>
              </b-dropdown>
            </div>
          </b-field>

          <b-field v-if="form.role_id == 3" :label="$t('areaPermission')" horizontal class="mb-4">
            <b-dropdown
              v-model="form.areas"
              multiple
              scrollable
              max-height="200"
              aria-role="list"
            >
              <template #trigger>
                <b-select :placeholder="form.areas.length ? $t('selected') + ': ' + form.areas.length : $t('selectArea')" />
              </template>
              <b-dropdown-item
                v-for="area in areas"
                :key="'area'+area.id"
                :value="area.id"
                aria-role="listitem"
              >
                <span>{{ area.name }}</span>
              </b-dropdown-item>
            </b-dropdown>
          </b-field>

          <b-field v-if="form.role_id != 5" label="Yetkiler" horizontal class="is-align-items-center mb-4">
            <div class="is-flex is-flex-direction-column">
              <div v-if="form.role_id == 4" class="field mb-2">
                <b-checkbox v-model="form.permissions" native-value="create_transfer" type="is-purple">
                  Taşıt Görevi Oluşturma
                </b-checkbox>
              </div>
              <div class="field is-flex">
                <b-checkbox v-model="form.permissions" native-value="self_drive">
                  Sürücüsüz Taşıt Görevi Oluşturma
                </b-checkbox>
              </div>
            </div>
          </b-field>

          <b-field v-if="!isCreate" :label="$t('txtstatus')" horizontal>
            <b-switch v-model="form.status" type="is-purple" />
          </b-field>
        </form>
      </card-component>
    </section>
  </div>
</template>
<script>
import { mapState, mapActions, mapGetters } from 'vuex'
import 'vue-phone-number-input/dist/vue-phone-number-input.css';
import { parsePhoneNumberFromString, AsYouType } from 'libphonenumber-js'
import {httpErrorHandler} from '@/utils/global-functions';

export default {
  name: 'UserCreateOrDetails',
  title: ({ $i18n }) => $i18n.t('titles.createUser'),
  components: {
    HeroBar: () => import('@/components/HeroBar'),
    CardComponent: () => import('@/components/CardComponent'),
    VuePhoneNumberInput: () => import('vue-phone-number-input'),
  },
  data () {
    return {
      isLoading: false,
      title: null,
      phoneCountryCode: 'TR',
      password_required: true,
      success_message: null,
      id: null,
      form: {
        name: null,
        username: null,
        email: null,
        phone: null,
        phonenumber: null,
        nationalNumber: null,
        password: null,
        password_confirmation: null,
        departments: [],
        vehicle_types: [],
        role_id: null,
        permissions: [],
        areas: [],
        status: true
      },
    }
  },
  computed: {
    ...mapState([
      'roles',
    ]),
    ...mapGetters({
      departments: 'departments/all',
      vehicleTypes: 'vehicleTypes/all',
      areas: 'areas/all',
    }),
    isCreate () {
      return this.$route.name === 'users.create'
    },
  },
  watch: {
    'form.password' () {
      if (!this.isCreate && this.form.password) {
        this.password_required = true
      }

      if (!this.isCreate && (this.form.password == null || this.form.password == '')) {
        this.password_required = false
      }
    }
  },
  beforeDestroy () {
    this.$store.commit('setAsideActiveMenuKey', '')
  },
  mounted () {
    if (this.roles.length === 0) {
      this.$store.dispatch('getRoles')
    }

    this.$store.commit('setAsideActiveMenuKey', 'users.index')

    this.getDepartments({ is_active: 1 })
    this.getVehicleTypes({ is_active: 1, per_page: -1 })
    this.getAreas()

    this.title = this.$t('createUser')
    this.success_message = this.$t('created')

    if (!this.isCreate) {
      this.title = this.$t('editUser')
      document.title = this.title
      this.success_message = this.$t('updated')

      this.showSpinner()

      this.$http.get('users/' + this.$route.params.id).then(({ data }) => {
        const user = data.data

        if (!user) {
          return this.$router.back()
        }

        this.id = user.id
        this.form.name = user.name
        this.form.username = user.username
        this.form.email = user.email
        this.form.phone = user.phone
        this.form.phonenumber = user.phone
        this.form.departments = user.departments.map(department => department.id)
        this.form.vehicle_types = user.vehicleTypes.map(vehicleType => vehicleType.id)
        this.form.areas = user.areas.map(areas => areas.id)
        this.form.role_id = user.role.id
        this.form.permissions = user.permissions
        this.form.status = user.status

        if (user.phone) {
          this.formatPhoneNumber(user.phone)
        }

        this.password_required = false
      }).catch(() => {
        this.$buefy.toast.open({
          message: this.$t('error'),
          type: 'is-warning',
        })
      }).finally(() => {
        this.hideSpinner()
      })
    }
  },
  methods: {
    ...mapActions({
      getDepartments: 'departments/index',
      getVehicleTypes: 'vehicleTypes/index',
      getAreas: 'areas/index',
    }),
    checkIfEligibleToSelect (input) {
      if (this.form.departments.length && this.form.vehicle_types.length) {
        this.$buefy.toast.open({
          message: 'Departman veya araç türü seçmelisiniz.',
          type: 'is-warning',
          queue: false,
        })

        this.form[input] = []
      }

      if (parseInt(this.form.role_id) !== 3 && parseInt(this.form.role_id) !== 2 && this.form.departments.length > 1) {
        this.form[input].shift()
      }
    },
    formatPhoneNumber (number) {
      const asYouType = new AsYouType()
      asYouType.input(number)

      if (asYouType.getNumber()) {
        const phoneNumber = parsePhoneNumberFromString(asYouType.getNumber().number, asYouType.getNumber().country)
        this.form.phonenumber = phoneNumber.formatNational()
        this.phoneCountryCode = asYouType.getNumber().country
      }
    },
    phoneNumberUpdate (data) {
      this.form.phone = data.e164;
    },
    checkPasswordMatch () {
      if (this.form.password !== this.form.password_confirmation) {
        document.getElementById('confirm_password').setCustomValidity('Passwords Don\'t Match');
      } else {
        document.getElementById('confirm_password').setCustomValidity('');
      }
    },
    btnSubmit () {
      if (this.$refs.form.checkValidity()) {
        return this.submit()
      }

      this.$refs.form.reportValidity()
    },
    submit () {
      this.isLoading = true

      let actionURL = 'users'
      let method = 'POST'

      if (!this.isCreate) {
        actionURL = 'users/' + this.id
        method = 'PUT'
      }

      this.$http({
        url: actionURL,
        method: method,
        data: this.form
      })
      .then(response => {
        if (response.status === 200 || response.status === 201) {
          this.$buefy.toast.open({
            message: this.success_message,
            type: 'is-success',
            queue: false,
          })

          this.$router.go(-1)
        }
      }).catch(function (xhr) {
          httpErrorHandler(xhr.response);
      }).finally(() => {
        this.isLoading = false
      })
    },
  },
}
</script>

<style>
.deparments-field .field-body > .field {
  flex-grow: 0;
}
</style>
